'use client';

import React from 'react';
import { Drawer } from 'src/components';
import { IconButton } from 'src/components/PulseUI/IconButton';
import { ListUpload } from '../ListUpload';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
const ListsUploaderDrawer = () => {
  const { isDrawerOpen, closeDrawer } = useDrawer();

  const handleClose = () => {
    closeDrawer('listsUploader');
  };

  return (
    <Drawer
      isOpen={isDrawerOpen('listsUploader')}
      onClose={handleClose}
      size="lg"
      hideBackdrop
    >
      <Drawer.Header
        className="bg-sky-100 text-primary border-b-0"
        data-testid="lists-uploader-header"
      >
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <p
              className="font-bold text-lg"
              data-testid="lists-uploader-title"
            >
              Lists
            </p>
          </div>
          <div className="flex items-center gap-2">
            <IconButton
              variant="plain"
              color="neutral"
              size="sm"
              onClick={handleClose}
              icon={faXmark}
              className="text-primary hover:bg-sky-200"
              data-testid="lists-uploader-close-button"
            />
          </div>
        </div>
      </Drawer.Header>
      <Drawer.Content>
        <div className="p-4">
          <ListUpload />
        </div>
      </Drawer.Content>
    </Drawer>
  );
};

export default ListsUploaderDrawer;
